const toggleResultInfo = (e: MouseEvent) => {
  const resultItem = (e.currentTarget as HTMLElement).closest('.results-item')

  if (!resultItem) throw new InvalidElementError()

  const isExpanded = resultItem.classList.contains('active')
  const itemHeading = resultItem.querySelector('.item-heading')
  const itemInfo = resultItem.querySelector('.item-info')

  if (!itemHeading || !(itemInfo instanceof HTMLElement)) throw new InvalidElementError()

  const delay = isExpanded ? 400 : 0;

  const allItems = document.querySelectorAll('.results-item.active');
  allItems.forEach((item) => {
    if (item !== resultItem) {
      item.classList.remove('active');
      const otherHeading = item.querySelector('.item-heading');
      const otherInfo = item.querySelector('.item-info') as HTMLElement;

      otherHeading?.setAttribute('aria-expanded', 'false');
      if (otherInfo) {
        otherInfo.setAttribute('aria-hidden', 'true');
        setTimeout(() => {
          otherInfo.classList.remove('expanded');
        }, 400);
      }
    }
  });

  itemHeading.setAttribute('aria-expanded', String(!isExpanded));
  itemInfo.setAttribute('aria-hidden', String(isExpanded));

  setTimeout(() => {
    itemInfo.classList.toggle('expanded');
  }, delay);

  resultItem.classList.toggle('active');
}

const resetFormHandler = () => {
  document.querySelector('.clear-form')?.addEventListener('click', () => {
    const searchInput = document.getElementById('searchFood') as HTMLInputElement
    const formResults = document.querySelectorAll('#resultItem li')

    searchInput.value = ''
    formResults.forEach((li) => li.remove())
    searchInput.focus()
  })
}

const setResultListners = () => {
  const results = document.querySelectorAll('.results-item .item-heading')

  results.forEach((element) => {
    if (!(element instanceof HTMLElement)) throw new InvalidElementError()

    element.addEventListener('click', toggleResultInfo)
  })
}

document.addEventListener('DOMContentLoaded', () => {
  const results = document.getElementById('results') as HTMLDivElement
  if (!results) return

  if (results.children.length > 1) {
    results.focus();
  }
})

document.addEventListener('DOMContentLoaded', () => {
  const dietaryAdviceHero = document.getElementById('dietaryAdviceHero') as HTMLElement | null
  const input = document.getElementById('searchFood') as HTMLInputElement | null
  const resultList = document.getElementById('resultItem') as HTMLUListElement | null
  const isPregnantPageInput = document.querySelector('input#isPregnantPage') as HTMLInputElement | null

  if (!dietaryAdviceHero || !input || !resultList || !isPregnantPageInput) return

  let baseUrl = (dietaryAdviceHero.getAttribute('data-base-url') || '').trim()

  if (!baseUrl.endsWith('/')) {
    baseUrl += '/'
  }

  input.addEventListener('keyup', async () => {
    const query = input.value
    const isPregnantPage = isPregnantPageInput.value

    if (query.length < 3) {
      resultList.innerHTML = ''
      resultList.removeAttribute('aria-label')
      return
    }

    try {
      const response = await fetch(
        `/api/DietaryAdvice?query=${encodeURIComponent(query)}&isPregnantAdvice=${isPregnantPage}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )

      if (!response.ok) {
        console.error('Failed to fetch dietary advice')
        return
      }

      const data = await response.json()
      resultList.innerHTML = ''
      resultList.removeAttribute('aria-label')

      data.foodAdviceList.forEach((item: { synonyms: { name: string; url: string }[] }) => {
        item.synonyms.forEach((synonym: { name: string; url: string }) => {
          const li = document.createElement('li')
          li.innerHTML = `<a href="${baseUrl}${synonym.url}"><span>${synonym.name}</span></a>`
          resultList.appendChild(li)
        })
      })

      if (data.foodAdviceList.length) {
        const li = document.createElement('li')
        li.innerHTML = `<div class='bubble-link'><button class='link-button'>Sök</button></div>`
        resultList.appendChild(li)
        resultList.setAttribute('aria-label', 'Sökförslag')
      }
    } catch (error) {
      console.error('Error during fetch:', error)
    }
  })

  setResultListners()
  resetFormHandler()
})

const toggleAttribute = (el: HTMLElement, attr: string) => {
  const currentValue = el.getAttribute(attr)
  el.setAttribute(attr, String(currentValue !== 'true'))
}

const onToggleExpand = (e: MouseEvent) => {
  e.preventDefault()
  const toggle = e.currentTarget as HTMLElement
  const moreInfo = toggle.nextElementSibling as HTMLElement

  moreInfo.classList.toggle('active')
  toggleAttribute(moreInfo, 'aria-hidden')

  toggle.classList.toggle('active')
  toggleAttribute(toggle, 'aria-expanded')
}

const buildExpandNode = () => {
  const anchor = document.createElement('a')
  const spanShow = document.createElement('span')
  const spanHide = document.createElement('span')
  const iconPlus = document.createElement('i')
  const iconMinus = document.createElement('i')
  const textShow = document.createTextNode('Visa mer')
  const textHide = document.createTextNode('Visa mindre')

  anchor.className = 'info-expand'
  anchor.setAttribute('aria-expanded', 'false')
  anchor.href = '#'
  spanShow.className = 'expand-more'
  spanHide.className = 'expand-less'
  iconPlus.className = 'fa fa-plus expand-icon'
  iconMinus.className = 'fa fa-minus expand-icon'

  spanShow.appendChild(iconPlus)
  spanShow.appendChild(textShow)
  spanHide.appendChild(iconMinus)
  spanHide.appendChild(textHide)
  anchor.appendChild(spanShow)
  anchor.appendChild(spanHide)
  anchor.addEventListener('click', onToggleExpand)

  return anchor
}

const moreInfoHandler = () => {
  const moreInfoList = document.querySelectorAll('.more-info')

  moreInfoList.forEach((el) => el.before(buildExpandNode()))
}

moreInfoHandler()

class InvalidElementError extends Error {}
